import { orderHistory } from './order-history-de.i18n';

export const de = {
  orderHistory,
};
